import React from 'react'
import PropTypes from 'prop-types'

import { HeadlineContext } from '@aok/text-elements'

import { APIContext } from './APIContext'
import { PrivacyContext } from './PrivacyContext'
import { ClientListContext } from './ClientListContext'
import { clientListPropTypes, privacyPropTypes } from '../utils/commonPropTypes'

/**
 * Combines all global context providers into one
 */
const CombinedContextProvider = ({ apis, privacy, clientList, children }) => {
  return (
    <ClientListContext.Provider value={clientList}>
      <PrivacyContext.Provider value={privacy}>
        <APIContext.Provider value={apis}>
          <HeadlineContext.Provider
            value={{
              level: 1,
              tag: 'h1',
              disabled: false,
            }}
          >
            {children}
          </HeadlineContext.Provider>
        </APIContext.Provider>
      </PrivacyContext.Provider>
    </ClientListContext.Provider>
  )
}

CombinedContextProvider.propTypes = {
  apis: PropTypes.object,
  privacy: PropTypes.shape(privacyPropTypes),
  clientList: clientListPropTypes,
  children: PropTypes.node,
}

CombinedContextProvider.defaultProps = {
  privacy: {},
  clientList: [],
}

export default CombinedContextProvider
